import React, { forwardRef, useImperativeHandle, useRef } from "react";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_V2_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY ||
  "6Le9AygqAAAAAD_bHjq6FGmiX0T0-lE3OOBU4lUF";

/**
 * v2 captcha widget with imperative `reset()` exposed via ref.
 *
 * Props:
 *   onChange(token)  - token string when solved, "" when unchecked
 *   onExpired()      - fired when the token expires
 *   sitekey          - optional override for the v2 site key
 */
const CaptchaV2 = forwardRef(function CaptchaV2(
  { onChange, onExpired, sitekey },
  ref
) {
  const recaptchaRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      reset: () => {
        if (recaptchaRef.current && recaptchaRef.current.reset) {
          recaptchaRef.current.reset();
        }
      },
    }),
    []
  );

  return (
    <ReCAPTCHA
      ref={recaptchaRef}
      sitekey={sitekey || RECAPTCHA_V2_SITE_KEY}
      onChange={onChange}
      onExpired={onExpired}
    />
  );
});

export default CaptchaV2;
